import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LucideAngularModule, Smartphone, X, Share2, PlusSquare, CheckCircle2 } from 'lucide-angular';
import { PwaInstallService } from '../../../services/pwa-install.service';

@Component({
  selector: 'app-install-guide-modal',
  standalone: true,
  imports: [CommonModule, LucideAngularModule],
  templateUrl: './install-guide-modal.component.html',
  styleUrl: './install-guide-modal.component.scss'
})
export class InstallGuideModalComponent {
  readonly pwaService = inject(PwaInstallService);

  readonly Smartphone = Smartphone;
  readonly X = X;
  readonly Share2 = Share2;
  readonly PlusSquare = PlusSquare;
  readonly CheckCircle2 = CheckCircle2;

  close(): void {
    this.pwaService.closeGuideModal();
  }

  closeOnBackdrop(event: MouseEvent): void {
    if ((event.target as HTMLElement).classList.contains('guide-modal-overlay')) {
      this.close();
    }
  }
}
